<template>
  <q-page-container>
    <q-page>
      <section class="q-px-md q-py-lg flex column">
        <div class="header-page">
          <h4>Opções de atendimento</h4>

          <p>Selecione o tipo de atendimento desejado:</p>
        </div>
        <div class="q-py-md options-list">
          <div
            v-if="!optionsList.length"
            class="col-12 full-height flex justify-center items-center"
          >
            <q-circular-progress
              indeterminate
              rounded
              size="60px"
              color="red"
              class="q-ma-md"
            />
          </div>
          <div
            class="option-items"
            v-else
            v-for="item in optionsList"
            :key="item.id_opcao_atendimento"
          >
            <q-btn
              style="border-radius: 8px"
              class="q-my-sm full-width q-py-md"
              color="red-9"
              :label="item.opcao"
              @click="redirectRouterAttendace(item)"
            />
          </div>
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
import FinishActivityService from "@/services/FinishActivityService";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

const finishActivityService = new FinishActivityService();

  export default {
    name: "OptionsList",
    components: {},
    setup() {
      const router = useRouter();
      let optionsList = ref([]);

      function redirectRouterAttendace(item) {
        router.push({
          name: "create-finish-activity",
          params: { os_type: item.id_opcao_atendimento, name_type: item.opcao },
        });
      }

      async function getServiceOptionList() {
        const options = await finishActivityService.getOptionList();

        optionsList.value = options.filter((item) => {
          return item.id_opcao_atendimento !== 31;
        });
      }

      onMounted(() => {
        getServiceOptionList();
      });

      return {
        optionsList,
        redirectRouterAttendace,
      };
    },
  };
</script>

<style lang="scss" scoped>
  section {
    display: flex;
    height: 100vh;
    width: 100vw;
  }

  .header-page {
    h4 {
      font-size: 1rem;
      font-weight: 700;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: left;
      color: red;
      margin: 0;
    }

    p {
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: left;
      color: grey;
      margin: 0;
    }
  }

  .options-list {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-y: auto;
    padding: 0px 8px 0px 8px;
  }

  .option-items {
    display: flex;
    width: 100%;
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: transparent;
    -webkit-border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb:vertical {
    background-color: #cccccc;
    -webkit-border-radius: 6px;
  }
</style>
